import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import _isNil from 'lodash/isNil';
import { getPriceDisplay } from '../../services/price';
import { PricePropType, PricePropTypeDefault, PriceSettingsPropType, PriceSettingsPropTypeDefault } from '../../types';
import './Price.css';
var defaultProps = _objectSpread(_objectSpread({}, PricePropTypeDefault), PriceSettingsPropTypeDefault);
function Price(_ref) {
  var amount = _ref.amount,
    precision = _ref.precision,
    displayZeroCost = _ref.displayZeroCost,
    hideCurrencySign = _ref.hideCurrencySign,
    hide = _ref.hide;
  if (_isNil(amount)) {
    return null;
  }
  if (hide) {
    return null;
  }
  var formattedAmount = getPriceDisplay(amount, {
    precision: precision,
    displayZeroCost: displayZeroCost,
    hideCurrencySign: hideCurrencySign
  });
  if (_isNil(formattedAmount) || formattedAmount === '') {
    return null;
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "price-container"
  }, formattedAmount);
}
Price.defaultProps = defaultProps;
export default Price;